import { createLogger } from '../../logger';
import { IS_PRODUCTION, IS_DEV } from './constants';

export const logger = createLogger({
  threshold: IS_PRODUCTION ? 'info' : 'debug',
  plain: !IS_DEV,
});
